import { createSlice } from '@reduxjs/toolkit';
export const uiInitialState = {
    playbackStatus: 'playing',
    cc: false,
    muted: false,
};
// Define reducers
const uiSlice = createSlice({
    name: 'ui',
    initialState: uiInitialState,
    reducers: {
        play(state) {
            state.playbackStatus = 'playing';
        },
        pause(state) {
            state.playbackStatus = 'paused';
        },
        toggleCC(state) {
            state.cc = !state.cc;
        },
        toggleMute(state) {
            state.muted = !state.muted;
            // If unmuted & CC is off, Muting should also toggle CC on.
            if (state.muted && !state.cc) {
                state.cc = true;
            }
        },
    },
});
export const { play, pause, toggleCC, toggleMute } = uiSlice.actions;
export default uiSlice.reducer;
// Define selectors
export const ccSelector = (state) => state.ui.cc;
export const mutedSelector = (state) => state.ui.muted;
export const playbackStatusSelector = (state) => state.ui.playbackStatus;
//# sourceMappingURL=ui.js.map